export default __webpack_public_path__ + "static/media/Cynthia_Zak_AHV_In_Moms_We_Trust.e3470393.jpg";